function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider } from 'styled-components';
import { ThemePropType, defaultTheme } from './constants';

var WeatherThemeProvider = function WeatherThemeProvider(_ref) {
  var theme = _ref.theme,
      children = _ref.children;
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: _extends(_extends({}, defaultTheme), theme)
  }, children);
};

WeatherThemeProvider.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node.isRequired,
  theme: ThemePropType
} : {};
WeatherThemeProvider.defaultProps = {
  theme: defaultTheme
};
export default WeatherThemeProvider;